/*
 *
 * OrderPatientSearch constants
 *
 */
export const scope = "app/OrderPatientSearch/";

export const DEFAULT_ACTION = `${scope}DEFAULT_ACTION`;

export const GET_PATIENTS = "app/OrderPatientSearch/GET_PATIENTS";
export const GET_PATIENTS_SUCCESS =
  "app/OrderPatientSearch/GET_PATIENTS_SUCCESS";
export const GET_PATIENTS_ERROR = "app/OrderPatientSearch/GET_PATIENTS_ERROR";
